import AnalyticsEngineBase from "../../../../src/common/analytics/analyticsenginebase";
import * as eventNames from "../../../../src/common/analytics/analyticsevents";
import Mixpanel from "mixpanel-browser";
import CookieManager from "../../../../src/common/utilities/cookiemanager";

export default class MixpanelEngine extends AnalyticsEngineBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
    Mixpanel.init(options.mixpanelToken, {
      debug: options.mixpanelDebug,
    });
    this._UserIdentified = false;
    this._ListeningForEvents = false;
    Mixpanel.register_once({ userAgent: navigator.userAgent });
    // Bind context to use functions as event listeners
    this.pageEvent = this._pageEvent.bind(this);
    this.storyEvent = this._albEvent.bind(this);
    this.pageInBackground = this._pageInBackground.bind(this);
    this.pushBackgroundPages = this._pushBackgroundPages.bind(this);
    this.navigationSliderEvent = this._navigationSliderEvent.bind(this);
  }

  _identifyUser() {
    if (this._UserIdentified) return;
    else {
      let subscriptioncookie = CookieManager.getCookie(
        CookieManager.cookieKeys.LOGIN
      );
      if (subscriptioncookie == null) {
        // Gates open, no identifier
        return;
      }
      let cookieContent = JSON.parse(subscriptioncookie);
      if (cookieContent.hasOwnProperty("subscriptionUserReference")) {
        const mpID = "OA-" + cookieContent.subscriptionUserReference;
        Mixpanel.identify(mpID);
        const peopleInfo = {
          $last_login: new Date(),
          "User ID": mpID,
        };
        setTimeout(() => {
          Mixpanel.people.set(peopleInfo);
        }, 750);
      }
      this._UserIdentified = true;
    }
  }

  subscribeToEvents() {
    if (!this._ListeningForEvents) {
      this._analyticsManagerBase.on(
        eventNames.VIEW_ARTICLE_ALB,
        this.storyEvent
      );
      this._analyticsManagerBase.on(eventNames.VIEW_PAGE, this.pageEvent);
      this._analyticsManagerBase.on(
        eventNames.VIEW_PAGE_IN_BACKGROUND,
        this.pageInBackground
      );
      this._analyticsManagerBase.on(
        eventNames.CLOSED_ALB,
        this.pushBackgroundPages
      );
      this._analyticsManagerBase.on(
        eventNames.CLICKED_BOTTOM_NAVIGATION_READER,
        this.navigationSliderEvent
      );
      this._ListeningForEvents = true;
    }
  }

  unsubscribeFromEvents() {
    if (this._ListeningForEvents) {
      this._analyticsManagerBase.off(
        eventNames.VIEW_ARTICLE_ALB,
        this.storyEvent
      );
      this._analyticsManagerBase.off(eventNames.VIEW_PAGE, this.pageEvent);
      this._analyticsManagerBase.off(
        eventNames.CLOSED_ALB,
        this.pushBackgroundPages
      );
      this._analyticsManagerBase.off(
        eventNames.CLICKED_BOTTOM_NAVIGATION_READER,
        this
      );
      this._ListeningForEvents = false;
    }
  }

  _albEvent(data) {
    this._identifyUser();
    const {
      deviceContext: {
        app: { appVersion },
      },
      eventData: {
        bundle: {
          editionName: publication,
          bundleDateTime: issuedate,
          publication: {
            pages: [page],
            publicationName: issue,
          },
        },
      },
    } = data;

    const {
      articles: [{ articleReference: storyID, title, author }],
    } = page;
    Mixpanel.track("Pageview", {
      "App version": appVersion,
      ContentType: "article",
      ArticleByline: author,
      ArticleID: storyID,
      ArticleTitle: title,
      PublishDate: new Date(issuedate).toISOString(),
      ContentLayout: "newspaper view",
      Platform: "webreplica",
      PublicationDate: new Date(issuedate).toISOString(),
      CategoryLevelOne: page.section,
      PageOrScreenName: `${page.pagePosition}`,
      BrandGeography: publication,
      ArticleSource: "paper",
      Brand: issue,
      "Clean Url": window.location.href.split("?")[0],
    });
  }

  _pageEvent(data) {
    this._identifyUser();
    const {
      deviceContext: {
        app: { appVersion },
      },
      eventData: {
        bundle: {
          editionName: publication,
          bundleDateTime: issuedate,
          publication: { pages, publicationName: issue },
        },
      },
    } = data;
    pages.forEach((page) => {
      Mixpanel.track("Pageview", {
        ContentType: "issue page",
        "App version": appVersion,
        PublishDate: new Date(issuedate).toISOString(),
        CategoryLevelOne: page.section,
        ContentLayout: "newspaper view",
        Platform: "webreplica",
        PublicationDate: new Date(issuedate).toISOString(),
        PageOrScreenName: `${page.pagePosition}`,
        BrandGeography: publication,
        Brand: issue,
        "Clean Url": window.location.href.split("?")[0],
      });
    });
  }

  _pageInBackground(data) {
    const {
      deviceContext: {
        app: { appVersion },
      },
      eventData: {
        bundle: {
          editionName: publication,
          bundleDateTime: issuedate,
          publication: { pages, publicationName: issue },
        },
      },
    } = data;
    this.lastEvents = [];
    pages.forEach((page) => {
      this.lastEvents.push({
        "App version": appVersion,
        PublishDate: new Date(issuedate).toISOString(),
        CategoryLevelOne: page.section,
        ContentLayout: "newspaper view",
        Platform: "webreplica",
        PublicationDate: new Date(issuedate).toISOString(),
        PageOrScreenName: `${page.pagePosition}`,
        BrandGeography: publication,
        Brand: issue,
        "Clean Url": window.location.href.split("?")[0],
      });
    });
  }

  _pushBackgroundPages() {
    if (this.lastEvents) {
      this.lastEvents.forEach((event) => {
        Mixpanel.track("Pageview", {
          ContentType: "issue page",
          "App version": event["App version"],
          PublishDate: event["PublishDate"],
          ContentLayout: event["ContentLayout"],
          CategoryLevelOne: ["CategoryLevelOne"],
          Platform: event["Platform"],
          PublicationDate: event["PublicationDate"],
          PageOrScreenName: event["PageOrScreenName"],
          BrandGeography: event["BrandGeography"],
          Brand: event["Brand"],
          "Clean Url": event["Clean Url"],
        });
      });
    }
  }

  _navigationSliderEvent(data) {
    const {
      deviceContext: {
        app: { appVersion },
      },
      eventData: {
        bundle: {
          editionName: publication,
          bundleDateTime: issuedate,
          publication: { publicationName: issue },
        },
      },
    } = data;

    Mixpanel.track("Pageview", {
      ContentType: "pagecard",
      "App version": appVersion,
      PublishDate: new Date(issuedate).toISOString(),
      ContentLayout: "newspaper view",
      Platform: "webreplica",
      PublicationDate: new Date(issuedate).toISOString(),
      BrandGeography: publication,
      ArticleSource: "paper",
      Brand: issue,
      "Clean Url": window.location.href.split("?")[0],
    });
  }
}



// WEBPACK FOOTER //
// ./clients/dmg-sco/js/engines/MixpanelEngine.js